/**
 * Derived from flubber@0.4.2 (MIT).
 * Adapted for dependency-free internal ESM use in anvil2.
 */
import { distance, pointAlong, polygonLength, type Ring } from "./math";

export function addPoints(ring: Ring, numPoints: number) {
  if (!numPoints) {
    return;
  }

  const desiredLength = ring.length + numPoints;
  const step = polygonLength(ring) / numPoints;

  let index = 0;
  let cursor = 0;
  let insertAt = step / 2;

  while (ring.length < desiredLength) {
    const start = ring[index];
    const end = ring[(index + 1) % ring.length];
    const segmentLength = distance(start, end);

    if (insertAt <= cursor + segmentLength) {
      ring.splice(
        index + 1,
        0,
        segmentLength
          ? pointAlong(start, end, (insertAt - cursor) / segmentLength)
          : [...start],
      );
      insertAt += step;
      continue;
    }

    cursor += segmentLength;
    index += 1;
  }
}

export function bisect(
  ring: Ring,
  maxSegmentLength = Number.POSITIVE_INFINITY,
) {
  for (let index = 0; index < ring.length; index += 1) {
    const start = ring[index];
    let end = index === ring.length - 1 ? ring[0] : ring[index + 1];

    while (distance(start, end) > maxSegmentLength) {
      end = pointAlong(start, end, 0.5);
      ring.splice(index + 1, 0, end);
    }
  }
}
